var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.34 10.56L11.44 0.66C11 0.22 10.45 0 9.9 0H2.2C0.99 0 0 0.99 0 2.2V9.9C0 10.45 0.22 11 0.66 11.44L10.56 21.34C11 21.78 11.55 22 12.1 22C12.65 22 13.2 21.78 13.64 21.34L21.34 13.64C21.78 13.2 22 12.65 22 12.1C22 11.55 21.78 11 21.34 10.56ZM12.1 19.8L2.2 9.9V2.2H9.9L19.8 12.1L12.1 19.8ZM4.95 3.3C5.83 3.3 6.6 4.07 6.6 4.95C6.6 5.83 5.83 6.6 4.95 6.6C4.07 6.6 3.3 5.83 3.3 4.95C3.3 4.07 4.07 3.3 4.95 3.3ZM8.91 7.59L10.45 6.05L16.5 12.1L14.96 13.64L8.91 7.59ZM6.16 10.34L7.7 8.8L12.1 13.2L10.56 14.74L6.16 10.34Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/TagIcon.358c6f24924338d0216d0f5457cf189f.svg";
export { ForwardRef as ReactComponent };